"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RatingStarsMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Icon = require("../../components/Icon/Icon.styles");
var _spaceMixin = require("../spaceMixin");
/** @class RatingStars */
/** @method */
var RatingStarsMixin = function RatingStarsMixin(props) {
  var value = props.value;
  return (0, _styledToken.default)({
    fontSize: 'RatingStars.fontSize',
    valueColor: 'RatingStars.valueColor',
    noValueColor: 'RatingStars.noValueColor',
    marginRight: 'RatingStars.marginRight'
  }, function (_ref) {
    var fontSize = _ref.fontSize,
      valueColor = _ref.valueColor,
      noValueColor = _ref.noValueColor,
      marginRight = _ref.marginRight;
    return (0, _styledComponents.css)(["display:inline-flex;font-size:", "px;", "{color:", ";&:not(:last-child){margin-right:", ";}}"], fontSize, _Icon.StyledIcon, value === null ? noValueColor : valueColor, marginRight ? marginRight + "px" : (0, _spaceMixin.spaceMixin)(0.5)(props));
  })(props);
};
exports.RatingStarsMixin = RatingStarsMixin;